// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"26e6bbb9","453":"9d3cd94e","455":"af1ff56d"}[chunkId] + ".chunk.js";
};